import * as MUTATION_TYPES from "./mutation-types";
import * as GETTER_TYPES from "./getter-types";

export const snackbarState = {
  snackbar: {
    text: '',
    color: '',
    value: false,
    timeout: 5000
  }
};

export const snackbarGetters = {
  [GETTER_TYPES.GET_SNACKBAR](state) {
    return state.snackbar;
  }
}

export const snackbarMutations = {
  [MUTATION_TYPES.SET_SNACKBAR](state, payload) {
    state.snackbar = { ...payload }
  },
  [MUTATION_TYPES.SHOW_ERROR_SNACKBAR](state, text = 'Ha ocurrido un error') {
    state.snackbar = {
      ...state.snackbar,
      text,
      color: "error",
      value: true
    }
  }
};
